export const CITY_CREATE_RESET = 'CITY_CREATE_RESET'
export const CITY_CREATE_SET_CREATED = 'CITY_CREATE_SET_CREATED'
export const CITY_CREATE_SET_ERROR = 'CITY_CREATE_SET_ERROR'
export const CITY_CREATE_SET_VIOLATIONS = 'CITY_CREATE_SET_VIOLATIONS'
export const CITY_CREATE_TOGGLE_LOADING = 'CITY_CREATE_TOGGLE_LOADING'
